import styled from "styled-components";
import { CardComp, ButtonComp } from "..";
import { formatMoney } from "../../utils/currencyFormat";

const PropertyCard = styled(CardComp)`
  && {
    border: 1px solid #e5e5e5;
    border-radius: 15px;
    height: 100%;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &:hover {
    border-color: var(--color-primary-soft);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  }
`;

export default function RealEstatePropertyCard({ property, onRequest, onView }) {
  if (!property) return null;

  return (
    <PropertyCard cardClassName="h-100">
      <p className="small text-muted mb-1 text-uppercase fw-semibold" style={{ letterSpacing: "0.04em" }}>
        {property.landType}
      </p>
      <h3 className="h6 fw-bold mb-2" style={{ color: "#383838" }}>
        {property.name}
      </h3>
      <p className="text-muted small mb-2">{property.location}</p>
      <p className="small mb-3" style={{ color: "#525252", minHeight: 48 }}>
        {property.shortDescription}
      </p>
      <p className="fw-bold mb-1" style={{ color: "var(--color-primary)" }}>
        {formatMoney(property.pricePerUnitNgn)}
        <span className="text-muted fw-normal small"> / {property.unitLabel}</span>
      </p>
      <p className="text-muted small mb-3">{property.availableUnitsLabel} · indicative only</p>
      <div className="d-flex flex-wrap gap-2 mt-auto">
        {onView ? (
          <ButtonComp
            btnText="View details"
            type="button"
            btnClassName="btn btn-sm px-3 py-2 rounded-3 border"
            ButtonInlineStyle={{
              minWidth: 0,
              borderColor: "#e0e0e0",
              color: "#383838",
              background: "#fff",
            }}
            onClick={() => onView(property)}
          />
        ) : null}
        <ButtonComp
          btnText="Request property"
          type="button"
          btnClassName="btn btn-sm px-3 py-2 rounded-3"
          ButtonInlineStyle={{
            minWidth: 0,
            background: "var(--color-primary)",
            borderColor: "var(--color-primary)",
            color: "#fff",
          }}
          onClick={() => onRequest(property)}
        />
      </div>
    </PropertyCard>
  );
}
